import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import CompanyProfile from "@/pages/CompanyProfile.vue";
import PenawaranPemasukan from "@/pages/Pemasukan.vue";
import PengajuanPengeluaran from "@/pages/Pengeluaran.vue";
import Products from "@/pages/Products.vue";
import Layanan from "@/pages/Layanan.vue";
import Items from "@/pages/Items.vue";
import Transaction from "@/pages/Transaction.vue";
import MaksimumSubmissions from "@/pages/MaksimumSubmissions";
import PaymentMethods from "@/pages/PaymentMethods";
import PengajuanBelanja from "@/pages/Belanja.vue";
import SubmissionCategory from "@/pages/SubmissionCategory.vue";
import ProductCategory from "@/pages/ProductCategory.vue";
import Laporan from "@/pages/Laporan.vue";
import RequiresAuth from './middleware/requires-auth';
import { RequestPermission, UserHaveRoles } from './middleware/requires-role';
import IfAuth from './middleware/if-auth';

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
        },
      },
      {
        path: "manage-user",
        name: "Manage User",
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Users"
        },
        component: () => import('@/pages/ManageUser')
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile,
        meta: {
          //middlewares: [ RequestPermission ]
        },
      },
      {
        path: "company",
        name: "Company Profile",
        component: CompanyProfile,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Company"
        },
      },
      {
        path: "kategori-submission",
        name: "Kategori Submission",
        component: SubmissionCategory,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Company"
        },
      },
      {
        path: "kategori-produk",
        name: "Kategori Produk",
        component: ProductCategory,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Company"
        },
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import('@/pages/RolePermission')
      },
      {
        path: "product-interface",
        name: "Interfaces",
        component: () => import('@/pages/Lord/ProductInterface'),
        meta: {
          middlewares: [ UserHaveRoles ],
          roles: ["super_entity","super_admin"]
        }
      },
      {
        path: "pemasukan",
        name: "Penawaran Pemasukan",
        component: PenawaranPemasukan,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Company"
        },
      },
      {
        path: "pengeluaran",
        name: "Pengajuan Pengeluaran",
        component: PengajuanPengeluaran,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Company"
        },
      },
      {
        path: "produk",
        name: "Produk",
        component: Products,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Products"
        },
      },
      {
        path: "layanan",
        name: "Layanan",
        component: Layanan,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Layanan"
        },
      },
      {
        path: "items",
        name: "Items",
        component: Items,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Items"
        },
      },
      {
        path: "transaction",
        name: "Transaction",
        component: Transaction,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Transactions"
        },
      },
      {
        path: "belanja",
        name: "Pengajuan Belanja",
        component: PengajuanBelanja,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Belanja"
        },
      },
      {
        path: "utang",
        name: "Utang",
        component: () => import('@/pages/Utang')
      },
      {
        path: "piutang",
        name: "Piutang",
        component: () => import('@/pages/Piutang')
      },
      {
        path: "settings-maksimum-submissions",
        name: "Settings Maksimum Submissions",
        component: MaksimumSubmissions,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Settings Maksimum Submissions"
        },
      },
      {
        path: "wallet",
        name: "Wallet",
        component: PaymentMethods,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Metode Pembayaran"
        },
      },
      {
        path: "laporan",
        name: "Laporan Keuangan",
        component: Laporan,
        meta: {
          middlewares: [ RequestPermission ],
          permission: "Read Laporan"
        },
      },
      {
        path: "broadcast",
        name: "Broadcast",
        component: () => import('@/pages/Broadcast'),
        meta: {
          middlewares: [ UserHaveRoles ],
          roles: ["super_admin", "entity"]
        }
      },
      {
        path: "api-keys",
        name: "API Keys",
        component: () => import('@/pages/APIKeys'),
        meta: {
          middlewares: [ UserHaveRoles ],
          roles: ["super_admin", "entity"]
        }
      },
      {
        path: "notifikasi",
        name: "Notifikasi",
        component: () => import('@/pages/NotificationTopic'),
        meta: {
          middlewares: [ UserHaveRoles ],
          roles: ["super_admin", "entity"]
        }
      },
    ],
    meta: {
			middlewares: [ RequiresAuth ]
		}
  },
  {
    path: '/print/:id',
    name: 'Print Submission',
    component: () => import('@/pages/Print.vue')
  },
  {
    path: '/print-laporan/:tanggalFrom/:tanggalTo/:type',
    name: 'Print Laporan',
    component: () => import('@/pages/PrintLaporan.vue')
  },
  {
    path: "/login",
    name: "/login",
    component: () => import("@/pages/Login"),
    meta: {
			middlewares: [ IfAuth ]
		}
  },
  {
    path: "/change-password",
    name: "/change-password",
    component: () => import("@/pages/ChangePassword")
  },
  {
    path: "/error",
    name: "/error",
    component: () => import("@/pages/NotFound")
  },
  {
    path: "/registrasi",
    name: "/registrasi",
    component: () => import("@/pages/Registrasi"),
    meta: {
			middlewares: [ IfAuth ]
		}
  },
  {
    path: "/verymail",
    name: "/verymail",
    component: () => import("@/pages/VerifyEmailSuccess")
  },
  {
    path: "/registrasiAFP",
    name: "/registrasiAFP",
    component: () => import("@/pages/RegistrasiAFP"),
    meta: {
			middlewares: [ IfAuth ]
		}
  },
  {
    path: "/suratMandatAFP",
    name: "/suratMandatAFP",
    component: () => import("@/pages/SuratMandatAFP"),
    meta: {
			middlewares: [ IfAuth ]
		}
  },
  {
    path: "/listRegisterCongress",
    name: "/listRegisterCongress",
    component: () => import("@/pages/ListRegisterCongress"),
  },
  {
    path: "/BuyYoSimulasi",
    name: "/BuyYoSimulasi",
    component: () => import("@/pages/BuyYoSimulasi"),
  },
];

export default routes;
